// ======================= Imports =======================
import React from "react";
import { useNavigate } from "react-router-dom";
import "./PaymentSuccess.css";

// ======================= Main Component =======================
export default function PaymentSuccess({
  setIsBankOfAmericaPrepaidPaymentSuceeded,
  setCheckForBankOfAmericaPayment,
}) {
  // ======================= Router =======================
  let navigate = useNavigate();

  // ======================= Render =======================
  return (
    <div className="main-payment fixed  top-0 left-0">
      <div className="main-container flex flex-wrap flex-row justify-content-center align-items-start w-full">
        {/* ======================= Success Icon ======================= */}
        <div className="check-main">
          <i className="pi pi-check" />
        </div>
        {/* ======================= Success Message ======================= */}
        <h1>Payment Success!</h1>
        <p>Your Payment Has Been Proceed</p>
        {/* ======================= Redirect Button ======================= */}
        <div className="flex flex-wrap w-full flex-row justify-content-center items-center">
          <button
            onClick={() => {
              setIsBankOfAmericaPrepaidPaymentSuceeded(true);
              navigate("/");
              setCheckForBankOfAmericaPayment((prev) => !prev);
            }}
            className="redirect-button-success"
            label="Redirect Back"
          >
            Redirect Back
          </button>
        </div>
      </div>
    </div>
  );
}
